


































































































const namespace = 'form';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import axios, { AxiosResponse } from 'axios';
import OdataDropdown from '@/modules/form/components/OdataDropdown.vue';
import CountrySelect from '@/modules/form/components/CountrySelect.vue';
import OdataMulticheckbox from '@/modules/form/components/OdataMulticheckbox.vue';
import OdataImagesMultiSelect from '@/modules/form/components/OdataImagesMultiSelect.vue';
import FormInput from '@/modules/form/components/FormInput.vue';
import FormTextarea from '@/modules/form/components/FormTextarea.vue';
import NumericalInput from '@/modules/form/components/NumericalInput.vue';
import DateInput from '@/modules/form/components/DateInput.vue';
import YesNoRadio from '@/modules/form/components/YesNoRadio.vue';
import PaymentRestForm from '@/modules/form/components/PaymentRestForm.vue';
import MealsForm from '@/modules/form/components/MealsForm.vue';
import IFormState from '@/modules/form/interfaces/IFormState';
import IFormField from '@/modules/form/interfaces/IFormField';
import IFormFieldsData from '@/modules/form/interfaces/IFormFieldsData';

@Component({
    name: 'FormFields',
    components: {
        OdataDropdown,
        CountrySelect,
        OdataMulticheckbox,
        OdataImagesMultiSelect,
        FormInput,
        FormTextarea,
        NumericalInput,
        DateInput,
        YesNoRadio,
        PaymentRestForm,
        MealsForm,
    },
})
export default class FormFields extends Vue {
    @Prop() public formState?: IFormState;
    @Prop() public keyId!: number;
    @Prop() public keyGuid!: string;
    @Prop() public eventId!: number;
    @Prop() public eventTypeId!: number;
    @Prop() public eventRegistrationId!: number;
    @Getter('apiUrl', { namespace: 'configuration' }) private apiUrl!: string;
    @Getter('currentFormState', { namespace }) private currentFormState!: IFormState;
    private formFields: IFormField[] = [];

    private errored = false;
    private loading = false;
    private valitationPassed = true;

    private get RegistrationFormFieldsUrl() {
        let url = '/odata/forms/FormFields';
        if (this.eventRegistrationId > 0) {
            url = `/odata/registrations/EventRegistrations(${this.eventRegistrationId})/FormFields`;
        }

        return url;
    }

    private get userComeFromReferenceLink() {
        const recomendee = this.$route.query.rec as string;
        return recomendee !== undefined;
    }

    private get userComeFromSpecialCodeLink() {
        const specialCode = this.$route.query.sc as string;
        return specialCode !== undefined;
    }

    private get currentFormFields() {
        return this.formFields;
    }

    // private get currentFormState() {
    //     return this.formState;
    // }

    @Watch('formState', { immediate: true, deep: true })
    private onFormStateChanged(val: IFormState) {
        if (val !== undefined) {
            this.loadFormFields('?$filter=FormStateId eq ' + val.Id);
        } else {
            console.error('FormState is undefined.');
        }
    }

    private onSubmit(event: Event, formState: IFormState, formField: IFormField): void {
        // TODO: findout how to trigger native HTML5 validation
        this.valitationPassed = this.validateFormFields(this.formFields);
        if (!this.valitationPassed) {
            return;
        }

        this.$emit('formSubmit', this.getFormFieldsData(formState, formField));
    }

    private validateFormFields(formFields: IFormField[]): boolean {
        formFields.forEach(field => {
            if (
                field.IsVisible &&
                field.IsRequired &&
                (field.Value === undefined || field.Value === null || field.Value === '')
            ) {
                field.ErrorMessage = field.Name + ' is required.';
                console.log(field.Name + ' is required.');
            } else {
                field.ErrorMessage = '';
            }
        });

        if (formFields.some(f => f.ErrorMessage !== '')) {
            return false;
        }

        return true;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onMealsSelected(args: any) {
        this.$emit('mealsSelected', args);
    }

    private getSubmitButtonId(formState: IFormState) {
        return formState.Name.toLowerCase() + '-button';
    }

    private getFormFieldsData(formState: IFormState, formField: IFormField) {
        const dropdownChangeDetails: IFormFieldsData = {
            trigger: formField.Value,
            formFields: this.formFields,
            formState,
        };

        return dropdownChangeDetails;
    }

    private loadFormFields(filter?: string) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;

        if (this.eventRegistrationId === undefined || this.eventRegistrationId === null) {
            this.eventRegistrationId = 0;
        }

        const url = this.apiUrl + this.RegistrationFormFieldsUrl;
        self.loading = true;
        axios
            .get(url + filter)
            .then((response: AxiosResponse) => {
                const sortedFields = response.data.value.sort((a: IFormField, b: IFormField) => a.Order - b.Order);
                self.formFields = sortedFields;
            })
            .catch((error: object) => {
                console.log(error);
                self.errored = true;
            })
            .finally(() => (self.loading = false));
    }
}
